// PasswordInput.js
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const PasswordInput = ({ label, value, onChange, required }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="field relative">
      <label className="block font-medium mb-2">{label}{required && '*'}</label>
      <input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        className="w-full border rounded-lg p-2 border-[rgb(161,147,147)] focus:ring focus:ring-blue-500 bg-[rgba(255,255,255,0.09)]"
        required={required}
        aria-describedby="password-error"
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-11 text-lg text-gray-500"
      >
        {showPassword ? <FaEye className='text-primary'/> : <FaEyeSlash />}
      </button>
    </div>
  );
};

export default PasswordInput;
